import { render } from "./editorForm.vue?vue&type=template&id=1a5b579e&scoped=true"
import script from "./editorForm.vue?vue&type=script&lang=js"
export * from "./editorForm.vue?vue&type=script&lang=js"

import "./editorForm.vue?vue&type=style&index=0&id=1a5b579e&lang=css&scoped=true"

import exportComponent from "D:\\xampp\\htdocs\\jump\\front\\jumpsa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5b579e"]])

export default __exports__